/*
 * @Author: liuxiaoling 
 * @Date: 2021-05-28 15:16:22 
 * @Last Modified by: liuxiaoling
 * @Last Modified time: 2021-06-03 15:13:47
 * @description:  客服技能组入口
 */
import request from '@/utils/request'
import { getRequest } from '@/utils'

export function skillGroups () {
    return request({
        url: 'chat/skill/group',
        method: 'get',
        params: {
            c: getRequest().c,
            e: getRequest().e
        }
    })
}

export function turnHumanService (data) {
    return request({
        url: 'chat/transfer/group',
        method: 'post',
        data
    })
}
